import { Field, FieldArrayRenderProps } from "@progress/kendo-react-form";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import React from "react";
import {
  closeDialog,
  openDialog,
} from "../../../components/dialog/dialogSlice";
import { setDeleteIndex } from "../tourSlice";
import { Card, GridLayout, GridLayoutItem } from "@progress/kendo-react-layout";
import { Button } from "@progress/kendo-react-buttons";
import AppDialog, {
  DialogCloseButton,
} from "../../../components/dialog/Dialog";
import { Typography } from "@progress/kendo-react-common";
import IconButton from "../../../components/common/IconButton";
import { MdDelete } from "react-icons/md";
import FormSelectionField from "../../../components/formFields/FormSelectionField";
import FormTextField from "../../../components/formFields/FormTextField";
import { requiredValidator } from "../../../components/formFields/CommonValidator";
import FormMultiSelectionFiled from "../../../components/formFields/FormMultiSelectionFiled";
import FormRichTextField from "../../../components/formFields/FormRichTextField";
import { getItineraryByID } from "../../itinerary/services/itinerary.services";
import { ISectorCity } from "../../sector/sectorModel";

const TourItineraryArray = (fieldArrayRenderProps: FieldArrayRenderProps) => {
  const dispatch = useAppDispatch();
  const TourItineraryDeleteIndex = useAppSelector(
    (state) => state.tour.deleteIndex
  );
  const dialogName = useAppSelector((state) => state.dialog.dialogName);
  const SectorCityList = useAppSelector((state) => state.sector.SectorCityList);
  const ItineraryList = useAppSelector(
    (state) => state.itinerary.ItineraryList
  );
  const ItineraryFacilityList = useAppSelector(
    (state) => state.itineraryfacility.ItineraryFacilityList
  );

  const handleOpenDeleteDialog = (index: number) => {
    dispatch(openDialog("tourItineraryDeleteDialog"));
    dispatch(setDeleteIndex(index));
  };

  const handleDeleteAction = React.useCallback(
    (index: number) => {
      fieldArrayRenderProps.onRemove({ index: index });
      dispatch(closeDialog());
      dispatch(setDeleteIndex(-1));
    },
    [fieldArrayRenderProps]
  );

  const pushElementInarray = React.useCallback(() => {
    fieldArrayRenderProps.onPush({
      value: {
        DayNo: null,
        TourID: null,
        ItineraryID: null,
        ItineraryDescription: "",
        CityID: null,
        HotelID: null,
        ItineraryFacilityID: "",
      },
    });
  }, [fieldArrayRenderProps]);

  // const filterHotels = (CityID: number) => {
  //   if (CityID) {
  //     const result = HotelList.filter((hotel: any) => {
  //       return hotel.CityID === CityID;
  //     });
  //     return result.map((hotel) => {
  //       return {
  //         value: hotel.ID,
  //         label: hotel.HotelName,
  //       };
  //     });
  //   }
  // };

  const filterItineary = (CityID: number) => {
    if (CityID) {
      const result = ItineraryList.filter((itineary: any) => {
        return itineary.CityID === CityID;
      });
      return result.map((itineary) => {
        return {
          value: itineary.ID,
          label: itineary.ItineraryTitle,
        };
      });
    }
  };

  const handleChangeItinerary = async (e: any, index: number) => {
    if (e?.value) {
      const res: any = await dispatch(getItineraryByID(e?.value));
      console.log("res", res);
      if (res.meta?.requestStatus === "fulfilled") {
        fieldArrayRenderProps.formRenderProps.onChange(
          `TourItinerary.${index}.ItineraryDescription`,
          {
            value: `${res.payload.Description}`,
          }
        );
      }
    } else {
      fieldArrayRenderProps.formRenderProps.onChange(
        `TourItinerary.${index}.ItineraryDescription`,
        {
          value: "<p></p>",
        }
      );
    }
  };

  return (
    <GridLayout cols={[{ width: "100%" }]}>
      {!fieldArrayRenderProps.value ? pushElementInarray() : null}
      <GridLayoutItem style={{ marginBottom: 10 }}>
        <Button
          fillMode={"solid"}
          themeColor={"primary"}
          onClick={pushElementInarray}
          type="button"
        >
          Add Tour Itinerary
        </Button>
      </GridLayoutItem>
      {dialogName === "tourItineraryDeleteDialog" && (
        <AppDialog>
          <>
            <Typography.h5>{"Delete Tour Itinerary"}</Typography.h5>
            <GridLayout>
              <GridLayoutItem>
                <Typography.p>
                  Are you sure you want to delete this?
                </Typography.p>
              </GridLayoutItem>
              <GridLayoutItem
                style={{
                  display: "flex",
                  justifyContent: "end",
                }}
              >
                <DialogCloseButton themeColor="error" />
                <Button
                  fillMode={"solid"}
                  themeColor={"error"}
                  onClick={() => handleDeleteAction(TourItineraryDeleteIndex)}
                  type="button"
                >
                  Delete
                </Button>
              </GridLayoutItem>
            </GridLayout>
          </>
        </AppDialog>
      )}
      {fieldArrayRenderProps.value &&
        fieldArrayRenderProps.value.length > 0 &&
        fieldArrayRenderProps.value.map((TourItinerary: any, index: number) => (
          <GridLayoutItem key={index}>
            <Card className="fieldarray-card">
              <GridLayout
                style={{ marginRight: 20 }}
                gap={{ rows: 0, cols: 10 }}
                cols={[
                  { width: "33.33%" },
                  { width: "33.33%" },
                  { width: "33.33%" },
                  // { width: "25%" },
                ]}
              >
                <GridLayoutItem>
                  <Field
                    name={`TourItinerary.${index}.DayNo`}
                    label="Day No"
                    placeholder="Day"
                    type="number"
                    component={FormTextField}
                    validator={requiredValidator}
                    astrike={true}
                  />
                </GridLayoutItem>
                <GridLayoutItem>
                  <Field
                    name={`TourItinerary.${index}.CityID`}
                    label="City"
                    placeholder="i.e. Ahmedabad"
                    component={FormSelectionField}
                    options={SectorCityList?.map((city: ISectorCity) => {
                      return {
                        value: city?.ID,
                        label: city?.CityName,
                      };
                    })}
                  />
                </GridLayoutItem>

                {/* <GridLayoutItem>
                  <Field
                    name={`TourItinerary.${index}.HotelID`}
                    label="Hotel"
                    placeholder="Hotel"
                    component={FormSelectionField}
                    // options={HotelList && filterHotels(TourItinerary.CityID)}
                  />
                </GridLayoutItem> */}
                <GridLayoutItem style={{ width: "100%" }}>
                  <Field
                    name={`TourItinerary.${index}.ItineraryID`}
                    label={"Itinerary"}
                    placeholder="Itinerary"
                    component={FormSelectionField}
                    validator={requiredValidator}
                    astrike={true}
                    options={
                      ItineraryList && filterItineary(TourItinerary.CityID)
                    }
                    onChange={(e: any) => {
                      handleChangeItinerary(e, index);
                    }}
                  />
                </GridLayoutItem>

                <GridLayoutItem colSpan={2} style={{ width: "100%" }}>
                  <Field
                    name={`TourItinerary.${index}.ItineraryDescription`}
                    label="Itinerary Description"
                    placeholder="Itinerary Description"
                    component={FormRichTextField}
                    validator={requiredValidator}
                    astrike={true}
                    contentHeight={200}
                  />
                </GridLayoutItem>

                <GridLayoutItem
                  style={{ width: "100%", display: "flex", gap: 10 }}
                >
                  <Field
                    name={`TourItinerary.${index}.ItineraryFacilityID`}
                    label={"Itinerary Facility"}
                    placeholder="Itinerary Facility"
                    wrapperClassName="w-100"
                    component={FormMultiSelectionFiled}
                    validator={requiredValidator}
                    astrike={true}
                    isSelectAll={true}
                    options={ItineraryFacilityList.map(
                      (itineraryfacility: any) => {
                        return {
                          value: itineraryfacility.ID,
                          label: itineraryfacility.Name,
                        };
                      }
                    )}
                  />
                  <IconButton
                    onClick={() => handleOpenDeleteDialog(index)}
                    disabled={fieldArrayRenderProps.value.length === 1}
                    themeColor={"error"}
                    size={"small"}
                    fillMode={"solid"}
                    type="button"
                    style={{ height: 30, width: 30, marginTop: 33 }}
                  >
                    <MdDelete
                      className="absolute-position"
                      style={{ fontSize: "20px" }}
                    />
                  </IconButton>
                </GridLayoutItem>

                {/* <GridLayoutItem
                  style={{ display: "flex", width: "100%", gap: 10 }}
                ></GridLayoutItem> */}
              </GridLayout>
            </Card>
          </GridLayoutItem>
        ))}
    </GridLayout>
  );
};

export default TourItineraryArray;
